import { getPersistentItem, setPersistentItem } from './persistence';
import { cookiesAccepted } from './cookies';

const STORAGE_ITEM_KEY = 'recruitment_saved_query_parameters';

export function getUtmData() {
    let current = getSavedQueryParams();
    let utmData = {};

    if (cookiesAccepted('analytics')) {
        Object.keys(current).map((key) => {
            if (key.startsWith('utm_') && key !== 'utm_referrer') {
                utmData[key] = current[key];
            }
        });

        if (utmData.utm_source === 'blog-lieferando' && utmData.utm_medium === 'referral') {
            utmData.utm_source = 'google';
            utmData.utm_medium = 'organic';
        }
        if (current.gclid) {
            utmData.utm_source = 'Google';
            utmData.utm_medium = 'cpc';
            utmData.utm_content = `GCLID: ${current.gclid}`;
        }
        if (current.utm_referrer && !utmData.utm_source && !utmData.utm_medium && !utmData.utm_content) {
            utmData.utm_source = current.utm_referrer;
            if (/google|bing/i.test(utmData.utm_source)) {
                utmData.utm_medium = 'organic';
            }
        }
    }

    return utmData;
}

export function saveQueryParams() {
    let urlParams = new URLSearchParams(window.location.search);
    let current = getSavedQueryParams();

    let storedCityParamPresent = Object.keys(current).includes('city');
    let urlCityParamPresent = false;
    urlParams.forEach((value, key) => {
        if (key === 'city') {
            urlCityParamPresent = true;
        }
        current[key] = value;
    });
    // if no ?city= present in url, then delete it from cache
    if (!urlCityParamPresent) {
        delete current['city'];
    }
    let newCityParamPresent = !storedCityParamPresent && urlCityParamPresent;

    if (document.referrer) {
        // Only save the data if it's from a different host then the current page
        let referrerUrl = new URL(document.referrer);
        if (referrerUrl.hostname !== window.location.hostname) {
            current.utm_referrer = referrerUrl.hostname;
        }
    }
    setPersistentItem(STORAGE_ITEM_KEY, current);

    return newCityParamPresent;
}

export function getQueryParam(key) {
    let current = getSavedQueryParams();

    return current[key] ?? undefined;
}

export function getQueryParamKeys() {
    return Object.keys(getSavedQueryParams());
}

function getSavedQueryParams() {
    return getPersistentItem(STORAGE_ITEM_KEY) || {};
}

export function getHasAppliedThroughJobPosting() {
    const currentParams = getSavedQueryParams();
    return currentParams.applied_through_job_posting ? 'yes' : 'no';
}

export function getHasAppliedThroughJobPostingBoolean() {
    return getHasAppliedThroughJobPosting() === 'yes';
}

// Read campaign flags from sessionStorage (set on landing page visit by GTM).
function getLandingPageFlag(storageKey) {
    try {
        return sessionStorage.getItem(storageKey) === 'true' ? 'yes' : 'no';
    } catch (e) {
        return 'no';
    }
}

// Used on form submit — URL has no campaign params when coming from a landing page.
export function getIsCampaignPageFlag() {
    return getLandingPageFlag('landing_is_campaign_page');
}

export function getIsYoungCouriersFlag() {
    return getLandingPageFlag('landing_is_young_couriers');
}

export function cleanQueryParams() {
    const currentParams = getSavedQueryParams();
    delete currentParams.vehicle_type;
    delete currentParams.working_hours;

    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    if (!searchParams.has('applied_through_job_posting')) {
        delete currentParams.applied_through_job_posting;
    }

    setPersistentItem(STORAGE_ITEM_KEY, currentParams);
}
